export default (request) => ({
  getBySlug: async (fieldNames) => {
    const response = await request({
      url: '/knock/v1/options',
      method: 'GET',
      params: {
        field_names: fieldNames.join(',')
      }
    });

    return response.data;
  }
});
